import { JobRole } from "~/normalizr/entities";
import { builderResourceListRow } from "~/sharedComponents/listRows/BaseResourceListRow";

export const JobRoleListRow = builderResourceListRow<JobRole>();
